import { createSlice } from '@reduxjs/toolkit';
import { getTotalInfluencer, getTransactionStats } from './actions';

const initialState = {
  influencer: {},
  transaction: [],
  isLoading: false,
  isLoadingTransaction: false,
  isError: false,
  errorMessage: {},
};

export const influencerStats = createSlice({
  name: 'influencerStats',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTotalInfluencer.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = {};
        state.influencer = {};
      })
      .addCase(getTotalInfluencer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getTotalInfluencer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.influencer = action.payload;
      })
      .addCase(getTransactionStats.pending, (state) => {
        state.isLoadingTransaction = true;
        state.isError = false;
        state.errorMessage = {};
        state.transaction = [];
      })
      .addCase(getTransactionStats.rejected, (state, action) => {
        state.isLoadingTransaction = false;
        state.isError = true;
        state.errorMessage = action.payload;
      })
      .addCase(getTransactionStats.fulfilled, (state, action) => {
        state.isLoadingTransaction = false;
        state.transaction = action.payload;
      });
  },
});

export default influencerStats.reducer;
